// extracted by mini-css-extract-plugin
export default {"hireBlock":"Hire_hireBlock__6VtWr","hireContainer":"Hire_hireContainer__JQLul","hireTitle":"Hire_hireTitle__HxPDG","hireButtons":"Hire_hireButtons__KWjGM"};